var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedTaxon)?_c('div',{staticClass:"mt-8 md:mt-0 pl-2 md:pl-0 font-semibold text-base text-blue-diagomics-dark"},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }